import {deliveryPresentation} from './delivery-source.js';
class DuepaDelivery extends HTMLElement {
  connectedCallback() {this.fallback ??= this.textContent;}
  configure(input) {
    this.fallback ??= this.textContent;
    const result = deliveryPresentation(input, this.dataset.productId, this.dataset.variantId);
    this.dataset.state = result.state;
    if (result.estimate) this.textContent = `${result.estimate.earliest} – ${result.estimate.latest}`;
    else this.textContent = this.fallback;
  }
}
if (!customElements.get('duepa-delivery')) customElements.define('duepa-delivery', DuepaDelivery);
